import { useRef } from "react";
import { isDeepEqual } from "./isDeepEqual";

/**
 * @param value the dependency array that is usually passed to useEffect
 * Note: use this hook if one or more of the deps are not primitives
 */

export const useDeepDeps = <T>(value: T) => {
  const ref = useRef<T>(value);

  if (!isDeepEqual(ref.current, value)) {
    ref.current = value;
  }

  return ref.current;
};
